module.exports = __webpack_public_path__ + "static/media/tools-area-zoom.88e4bca8.svg";